export const paramsFromQueryString = (query) => {
  var params = {};
  if (query) {
    var queryArray = query.split(";");
    queryArray = queryArray.filter((item) => item != "");
    queryArray.map((el) => el.replace(/\s/g, "") == "");
    queryArray.forEach(function (pair) {
      // var setting = pair.split(':')
      var setting = [pair.slice(0, pair.indexOf(":")), pair.slice(pair.indexOf(":") + 1)];
      // Convert option alias to a real name
      setting[0] = setting[0];
      setting[0]
        .trim()
        .split(".")
        .reduce(function (res, val, ind, col) {
          if (/^\d$/.test(val)) {
            // save text.0.text='hello' as object and then convert to array
            res.__toArray = true;
          }
          if (res[val] === undefined) {
            if (ind < col.length - 1) {
              res[val] = {};
            } else {
              try {
                res[val] = decodeURIComponent(setting[1] || "");
              } catch (ex) {
                res[val] = setting[1] || "";
              }
            }
          }

          //Checked types of values
          const filterNumber = Number.parseFloat(res[val]);
          const isCamera = setting[0].trim().includes('camera.orbit') || setting[0].trim().includes('camera.target');

          if (!isNaN(filterNumber) && !isCamera) {
            res[val] = filterNumber;
          } else if (res[val] === "true") {
            res[val] = new Boolean(1);
          } else if (res[val] === "false") {
            res[val] = new Boolean(0);
          }

          return res[val];
        }, params);
    });
  }
  return params;
};

/*
 * Remove zoom enable properties from options
 */
export const clearFromZoomProperties = (options) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return optionsRaw
    .filter((o) => o !== "zoom.enable:true")
    .filter((o) => o !== "zoom.enable:false")
    .join("; ");
};

/*
 * Remove video thumbnail properties from options
 */
export const clearFromVideoThumbnail = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("video.thumbnail") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

/*
 * Remove model thumbnail properties from options
 */
export const clearFromModelThumbnail = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("model.thumbnail") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

export const clearFromModelSkybox = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("skybox.image") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

export const clearFromModelEnvironment = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("environmentImage") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

export const clearFromModelSkyboxHeight = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("skybox.height") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

export const clearFromModelCameraOrbit = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("camera.orbit") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};

export const clearFromModelCameraTarget = (options, thumbStatus) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return thumbStatus
    ? optionsRaw
        .filter((o) => o.indexOf("camera.target") === -1)
        .map((o) => o.trim())
        .join("; ")
    : optionsRaw.map((o) => o.trim()).join("; ");
};
/*
 * Get video thumbnail value from options
 */
export const getVideoThumbnailOption = (options) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return optionsRaw
    .filter((o) => o.indexOf("video.thumbnail") !== -1)
    .join(";")
    .replace("video.thumbnail:", "");
};
/*
 * Get model thumbnail value from options
 */
export const getModelThumbnailOption = (options) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return optionsRaw
    .filter((o) => o.indexOf("model.thumbnail") !== -1)
    .join(";")
    .replace("model.thumbnail:", "");
};
/*
 * Get model thumbnail value from options
 */
export const getModelCertainOptions = (options) => {
  const optionsRaw = options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

  return optionsRaw
    .filter(
      (o) =>
        o.indexOf("model.thumbnail") !== -1 ||
        o.indexOf("skybox.image") !== -1 ||
        o.indexOf("environmentImage") !== -1
    )
    .join(";");
};

/*
 * Add prefix viewer. before option
 */
export const additionalOptions = (options) => {
  options = options.split(";").filter((option) => option !== "");
  let optionsLenght = options.length;
  options = options.map((option, i) => {
    if (optionsLenght === i + 1) {
      return `viewer.${option.trim()}`;
    }
    return `viewer.${option.trim()}`;
  });
  options = options.join("; ");
  return options;
};

export const decodeURIComponentX = (str) => {
  let out = "";
  let i = 0;
  let l;
  let x;
  const arr = str.split(/(%(?:D0|D1)%.{2})/);
  for (l = arr.length; i < l; i++) {
    try {
      x = decodeURIComponent(arr[i]);
    } catch (e) {
      x = arr[i];
    }
    out += x;
  }
  return out;
};

/*
 * CodeInline component
 */
export const clearOptions = (options) =>
  options
    .split(";")
    .filter((o) => o !== "")
    .map((o) => o.trim());

/*
 * Filter from zoom option
 */
export const filterOptionsFromZoom = (options) =>
  options
    .filter((o) => o !== "zoom.enable:true")
    .filter((o) => o !== "zoom.enable:false")
    .join("; ");

/*
 * RenderOptionsHTML
 */
export const renderOptionsHTML = (key, options) => {
  return options !== ""
    ? ` <span style="color: #606">${key}</span><span style="color: #660;">=</span><span style="color: #080;">"${options.trim()}"</span>`
    : "";
};
